<div class="rollback-migration-details">
    <div class="ag-grid-div">
        <ag-grid-angular #agGridRollBackMigrationDetails [style]="styleChipDiv" class="ag-theme-material" (gridReady)="onGridReady($event)"
            [columnDefs]="columnDefs" id="gridRollbackDetails"
            [defaultColDef]="defaultColDef"  [cacheBlockSize]="cacheBlockSize" [maxBlocksInCache]="maxBlocksInCache"
            [rowModelType]="rowModelType" [serverSideStoreType]="serverSideStoreType"
            [pagination]="agGridConfigurationService.paginationOn"  [paginationPageSize]="pageSize" 
            [overlayNoRowsTemplate]="overlayNoRowsTemplate" [gridOptions]="gridOptions" >
        </ag-grid-angular>            
    </div>
</div>